import React from 'react'
import { Card, CardContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'
import valueAdded from 'src/assets/RiskReport_images/valueAdded.svg'

const ValueAddedServices = () => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.upcomingRenewalsWrapper}>
        <Card classes={{ root: classes.root }}>
          <CardContent classes={{ root: classes.contentRoot }}>
            <div className={classes.renewalsItemWrapper}>
              <div className={classes.renewalsContent}>
                <div className={classes.legend}>
                  <span className={classes.legendTitle}>
                    Value Added Services by Trovity
                  </span>
                </div>
                <div>
                  <div>
                    <img
                      src={valueAdded}
                      className={classes.icon}
                      alt={'valueAdded'}
                    />
                  </div>
                  <div className={classes.contentContainer}>
                    <span className={classes.title}>
                      Ask your employees to go through their page wherein we
                      give all details of their coverage, nearest network
                      hospitals, and procedure to be followed for admission.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  )
}

export default ValueAddedServices

const useStyles = makeStyles({
  upcomingRenewalsWrapper: {
    marginTop: '0px',
  },
  contentContainer: {
    padding: '10px',
  },
  root: {
    borderRadius: '10px',
  },
  renewalsItemWrapper: {
    // display: "flex",
    alignItems: 'center',
    // height: "240px",
    overflow: 'hidden',
  },
  contentRoot: {
    padding: 0,
    '&:last-child': {
      padding: 0,
    },
  },
  legend: {
    maxWidth: '100vw',
    flexBasis: '150px',
    height: '50px',
    // marginTop: "-20px",
    background: COLORS.DARK_PINK,
    display: 'flex',

    alignItems: 'center',
  },
  legendTitle: {
    fontSize: '17px',
    lineHeight: '24px',
    color: COLORS.WHITE,
    fontWeight: 600,
    textAlign: 'center',
    marginLeft: '15px',
  },
  renewalsContent: {
    width: '100%',
    flexGrow: 1,
  },
  renewalsItem: {
    borderBottom: `0.7px solid ${COLORS.GREY_11}`,
    display: 'flex',
    alignItems: 'center',
    height: '50px',
    padding: '9px 10px',
    '&:last-child': {
      borderBottom: '0px solid',
    },
  },
  icon: { paddingTop: '20px', paddingBottom: '10px' },
  title: {
    fontSize: '13px',
    lineHeight: '18px',
    margin: '0 0 0 0',
    color: COLORS.GREY,
    flexBasis: '145px',
    flexShrink: 0,
  },
})
